
angular.module('tf.directives')

    .directive('donutChart', ['C3Service',function(C3Service) {
        return {
            restrict: 'E',
            template: '<div class="tf-donut"></div>',
            replace: true,
            scope:{
                data:"="
            },
            link : function(scope,element,attr){

                var data = scope.data? C3Service.pie(scope.data.values) : [];
                var chart = c3.generate({
                    bindto : element[0],
                    data: {
                        // iris data from R
                        columns: data,
                        type : 'donut',
                        onclick: function (d, i) { console.log("onclick", d, i); }
                        //onmouseover: function (d, i) { console.log("onmouseover", d, i); },
                        //onmouseout: function (d, i) { console.log("onmouseout", d, i); }
                    },

                    donut: {
                        label: {
                            format: function (value, ratio, id) {
                                return value;
                            }
                        }
                    },

                    color: {
                        pattern: ['#4E81BE', '#99BC57', '#F89546', '#9E403F', '#47ACC5', '#6C5083', '#C6D6A9', '#ff9896', '#9467bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5']
                    }

                });

                scope.$watch('data', function(data){
                    if(data) {
                        chart.load({
                            unload: true,
                            columns: C3Service.pie(data.values)
                        });
                    }
                });

            }
        };

    }]);